/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import _ from 'lodash';
import clsx from 'clsx';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
  handleTabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import PDFExportPanel from '../../../../../SharedModules/pdfExport/PDFExportPanel';
function LTTableGrid(props) {
  const {
    gridHeight,
    fileName,
    setFullScreenView,
    fullScreenView,
    fullScreenViewTable,
    fullScreenIcon,
    filterIcon,
    actionIcon,
    dataList,
    tableHeader,
    onSelect,
    onSelectionChanged,
    cellHead,
    setTotalResultCount,
    gridRef,
    cellClickedListener,
    helpMessage,
    rowSelection,
    rowMultiSelectWithClick,
    previewOkModalAction,
    isRowSelecteble,
    onCellValueChanged,
    onCellKeyDown,
    childPopup,
    ExtraFrameworkComponents,
  } = props;

  const [isFilter, setIsFilter] = React.useState(false);
  const [selectedRow, setISelectedRow] = React.useState(null);
  const [modalView, setModalView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(gridRef);
  const [columnApi, setColumnApi] = React.useState(null);

  const frameworkComponents = {
    TemplateNameCell: (cellInfo) => {
      const { name } = cellInfo.data;
      if (name && name.length > 25) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{`${name}`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    DescriptionCell: (cellInfo) => {
      const name = cellInfo.data.descr;
      if (name && name.length > 30) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{`${name}`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    TemplateNameCell1: (cellInfo) => {
      const { name } = cellInfo.data;
      if (name && name.length > 32) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{`${name}`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    DescriptionCell1: (cellInfo) => {
      const name = cellInfo.data.descr;
      if (name && name.length > 32) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{`${name}`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    ActionMergeCell: (cellInfo) => {
      return (
        <div className="icon-btn-group">
          <a
            variant="text"
            data-testid="excluded-ndcs-table-grid-delete"
            onClick={() => {
              setISelectedRow(cellInfo.node.data);
              setModalView(true);
            }}
          >
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="delete-tooltip">Delete</Tooltip>}
            >
              <SVGComponent iconName="Icon-delete" />
            </OverlayTrigger>
          </a>
        </div>
      );
    },
    CheckboxCell: (cellInfo) => (
      <ExtraFrameworkComponents.selectCheckBox {...cellInfo} />
    ),
    SortCheckboxCell: (cellInfo) => (
      <ExtraFrameworkComponents.sortCheckBox {...cellInfo} />
    ),
    SelectCheckboxCell: (cellInfo) => (
      <ExtraFrameworkComponents.orderTypeSelectBox {...cellInfo} />
    ),
  };
  const onGridReady = (params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  };
  const onFilterChangedGrid = React.useCallback((e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    if (
      e.api.getFilterModel() &&
      Object.keys(e.api.getFilterModel()).length > 0
    ) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, []);

  const handleClearFilter = () => {
    gridRef.current.clearFilters();
  };
  const handleFullScreenViewClick = () => {
    if (typeof setFullScreenView === 'function') {
      setFullScreenView(!fullScreenView);
    }
  };
  return (
    <div data-testid="letter-template-table-grid-component">
      {/* {tableHeader && (
        <div className="row top-header border-bottom">
          <div className="col-6">
            {fullScreenView ? (
              <div className="full-view-page-title">{fullScreenViewTable}</div>
            ) : (
              <p className="no-margin tbl-help-text p-1">{helpMessage || ''}</p>
            )}
          </div>
          <div className="col-6">
            <div className="th-icon-group start-right">
              {filterIcon && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="filter-tooltip">Reset All Filters</Tooltip>
                  }
                >
                  {isFilter ? (
                    <a
                      className="th-icon ic-filter-activate"
                      data-testid="handleClearFilter"
                      onClick={handleClearFilter}
                    >
                      <span className="ic-title"> Filter </span>
                    </a>
                  ) : (
                    <a className="th-icon ic-filter">
                      <span className="ic-title"> Filter </span>
                    </a>
                  )}
                </OverlayTrigger>
              )}

              {actionIcon && (
                <div className="th-icon ic-actions">
                  <PDFExportPanel
                    gridApi={gridApi}
                    columnApi={columnApi}
                    fileName={fileName || 'Letter Template'}
                    childRef={gridRef}
                    addRowsView
                  />
                </div>
              )}
              {fullScreenIcon && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="fullScreen-tooltip">
                      {!fullScreenView ? 'Full Screen' : 'Exit Full Screen'}
                    </Tooltip>
                  }
                >
                  <div
                    className={clsx(
                      'th-icon',
                      fullScreenView ? 'ic-fulScreen-exit' : 'ic-fulScreen'
                    )}
                    onClick={handleFullScreenViewClick}
                    data-testid="full-screen-action-btn"
                  >
                    <span className="ic-title"> Full Screen </span>
                  </div>
                </OverlayTrigger>
              )}
            </div>
          </div>
        </div>
      )} */}
      <TableGrid
        onGridReady={onGridReady}
        data-testid="letter-template-table-grid"
        ref={gridRef}
        onSelect={onSelect}
        onSelectionChanged={onSelectionChanged}
        rowSelection={rowSelection || 'single'}
        rowMultiSelectWithClick={rowMultiSelectWithClick || false}
        rowData={dataList}
        columnDefs={cellHead}
        suppressMenuHide
        gridHeight={gridHeight}
        animateRows
        sideBar
        helpMessage={helpMessage}
        exportFile={true}
        fileName={fileName || 'Letter Template'}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={
          typeof setFullScreenView === 'function'
            ? handleFullScreenViewClick
            : undefined
        }
        // isScrollOn
        domLayout="autoHeight"
        frameworkComponents={frameworkComponents}
        childPopup={childPopup}
        singleClickEdit={false}
        suppressNavigation={suppressNavigation}
        onFilterChanged={onFilterChangedGrid}
        setTotal={setTotalResultCount}
        cellClickedListener={cellClickedListener}
        onCellValueChanged={onCellValueChanged}
        onCellKeyDown={onCellKeyDown}
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={handleTabToNextCell}
        // enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        isRowSelecteble={isRowSelecteble}
      />
      {modalView && !_.isEmpty(selectedRow) && (
        <CommonModal
          data-testid="letter-template-table-grid-modal"
          className="dialog-420"
          open={modalView}
          viewAction
          viewHeader
          onOk={() => {
            previewOkModalAction(selectedRow);
            setModalView(false);
          }}
          okTitle="Yes"
          onClose={() => setModalView(false)}
          closeTitle="No"
          modalTitle="Warning"
          childrenComponent={
            <div className="p-3">
              Are you sure you want to Delete the selected field.
            </div>
          }
        />
      )}
    </div>
  );
}

export default LTTableGrid;